import React, { forwardRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const StudentIDCard = forwardRef(({ student, instituteName = "Institute Name" }, ref) => {
  // Generate QR code data
  const qrData = JSON.stringify({
    student_id: student.id,
    institute_id: student.institute_id || 1,
    card_id: `STU-${new Date().getFullYear()}-${student.id}`,
    type: 'attendance',
    issued_date: new Date().toISOString().split('T')[0]
  });

  return (
    <div ref={ref} className="id-card-container" style={{ pageBreakAfter: 'always' }}>
      <div className="id-card bg-white rounded-lg shadow-lg overflow-visible" style={{
        width: '350px',
        minHeight: '600px',
        margin: '20px auto',
        border: '2px solid #e5e7eb',
        fontFamily: 'Arial, sans-serif'
      }}>
        {/* Header */}
        <div className="card-header bg-gradient-to-r from-blue-600 to-blue-800 text-white p-4 text-center">
          <h2 className="text-xl font-bold mb-1">{instituteName}</h2>
          <p className="text-sm opacity-90">Student ID Card</p>
        </div>

        {/* Photo Section */}
        <div className="card-body p-4">
          <div className="photo-container flex justify-center mb-3">
            {student.photo ? (
              <img
                src={student.photo}
                alt={student.firstname}
                className="w-32 h-32 rounded-full object-cover border-4 border-blue-200"
              />
            ) : (
              <div className="w-32 h-32 rounded-full bg-blue-100 flex items-center justify-center border-4 border-blue-200">
                <span className="text-4xl font-bold text-blue-600">
                  {student.firstname?.charAt(0)}{student.lastname?.charAt(0)}
                </span>
              </div>
            )}
          </div>

          {/* Student Details */}
          <div className="student-details text-center mb-3">
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              {student.firstname} {student.lastname}
            </h3>
            
            <div className="details-grid text-left bg-gray-50 rounded-lg p-2 mb-3">
              <div className="detail-row flex justify-between py-1 border-b border-gray-200">
                <span className="text-sm font-semibold text-gray-600">Roll No:</span>
                <span className="text-sm text-gray-900">{student.roll_no || 'N/A'}</span>
              </div>
              <div className="detail-row flex justify-between py-1 border-b border-gray-200">
                <span className="text-sm font-semibold text-gray-600">Class:</span>
                <span className="text-sm text-gray-900">{student.class_name || 'N/A'}</span>
              </div>
              <div className="detail-row flex justify-between py-1 border-b border-gray-200">
                <span className="text-sm font-semibold text-gray-600">Batch:</span>
                <span className="text-sm text-gray-900">{student.batch_name || 'N/A'}</span>
              </div>
              <div className="detail-row flex justify-between py-1">
                <span className="text-sm font-semibold text-gray-600">Student ID:</span>
                <span className="text-sm text-gray-900">{student.id}</span>
              </div>
            </div>
          </div>

          {/* QR Code */}
          <div className="qr-code-container flex flex-col items-center mb-3">
            <div className="bg-white p-2 rounded-lg border-2 border-gray-300">
              <QRCodeCanvas
                value={qrData}
                size={80}
                level="H"
                includeMargin={true}
              />
            </div>
            <p className="text-xs text-gray-500 mt-2 font-semibold">Scan for Attendance</p>
          </div>
        </div>

        {/* Footer */}
        <div className="card-footer bg-gray-100 p-3 text-center">
          <p className="text-xs text-gray-600">
            Valid: {new Date().getFullYear()}-{new Date().getFullYear() + 1}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Issued: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
});

StudentIDCard.displayName = 'StudentIDCard';

export default StudentIDCard;
